const getStringFromBoolean = (value?: boolean) => (value === true ? 'yes' : value === false ? 'no' : undefined);

export default getStringFromBoolean;
